<template>
<div>
  <div class="container">
    <div class="row album-list">
      <div class=" col-sm-6 col col-md-4 col-lg-3"
           v-for="ne in news">
        <div class="new-box"> <img class="news-image"
               :src="ne.icon">
          <a :href="ne.link" target="_blank">
            <p class="new-text">{{ne.title}}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      news: [
        {
          'title': 'Venezolano del Cirque Du Soleil presentó su álbum debut como solista',
          'icon': '/static/news/elnacional.png',
          'link': 'http://www.el-nacional.com/noticias/entretenimiento/venezolano-del-cirque-soleil-presento-album-debut-como-solista_251230'
        },
        {
          'title': '"Luzia" Review- Cirque du Soleil\'s new show is "A Waking Dream of Mexico"',
          'icon': '/static/news/splash.png',
          'link': 'http://www.lasplash.com/publish/Entertainment/cat_index_chicago_entertainment/luzia-review.php'
        },
        {
          'title': '“Colors in My Mind” Nuevo álbum de Yilmer Vivas',
          'icon': '/static/news/corriente.png',
          'link': 'http://corrientealterna.net/2018/07/colors-mind-es-la-autobiografia-sonora-de-yilmer-vivas/'
        },
        {
          'title': '“Colors in My Mind” es la autobiografía sonora de Yilmer Vivas',
          'icon': '/static/news/ultnot.png',
          'link': 'http://www.ultimasnoticias.com.ve/noticias/entretenimiento/colors-in-my-mind-es-la-autobiografia-sonora-de-yilmer-vivas/'
        }
      ]
    }
  }
}

</script>

<style scoped="">

    



.container {
  margin-top: 30px;
}


.news-image {
  width: 120px;
  display: block;
  margin: 0 auto;
}

.imagew {}

.new-box {
  margin-top: 20px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  height: 95%;
  width: 95%;
  border: solid 4px rgb(110, 186, 208);
}

.new-box p{
  font-size: 14px;
  font-weight: 400;
}

.new-text {
  margin-top: 10px;
  opacity: 0.4;
  font-family: OpenSans;
  color: #505050;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: rgb(13, 13, 13);
}

.new-text:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/YilmerNews.vue